import { render, staticRenderFns } from "./PuntoDeEntrega.vue?vue&type=template&id=6dcee230&"
import script from "./PuntoDeEntrega.vue?vue&type=script&lang=js&"
export * from "./PuntoDeEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports